import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useOpportunitiesStore } from '@/store/opportunities';
import { useOpportunityStatusesStore } from '@/store/opportunityStatuses';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/opportunities/opportunities.config';
import { useRoute } from 'vue-router';

import Kanvan from '@/components/views/KanbanView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Opportunities',
  setup(__props) {

const route = useRoute();
const moduleName = (route.meta.moduleName ?? route.name) as string;
const preferencesStore = usePreferencesStore();

const opportunitiesStore = useOpportunitiesStore();
const opportunityStatusesStore = useOpportunityStatusesStore();


const {
  create,
  update,
  remove,
} = useModuleLayoutFetcher(
  moduleName,
  (params) => opportunityStatusesStore.fetchOpportunityStatuses(params),
  {
    create: opportunitiesStore.createOpportunity,
    update: (data) => opportunitiesStore.updateOpportunity(data.id, data),
    remove: opportunityStatusesStore.deleteOpportunityStatus,
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  preferencesStore.setAllModuleHeaders(HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const data = computed(() => opportunityStatusesStore.opportunityStatuses);

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(ViewsContainer, {
        moduleName: _unref(moduleName),
        listViewComponent: Kanvan,
        filterComponent: Filter,
        data: data.value,
        config: '@/components/modules/leads/leads.config',
        onCreate: _unref(create),
        onUpdate: _unref(update),
        onRecordUpdate: _unref(opportunitiesStore).updateOpportunity,
        onDelete: _unref(remove),
        show_toolbar: true,
        show_pagination: false,
        title: {singular:'Prospecto', plural:'Prospectos'}
      }, null, 8, ["moduleName", "data", "onCreate", "onUpdate", "onRecordUpdate", "onDelete"])
    ]),
    _: 1
  }))
}
}

})